Object.defineProperty(exports, '__esModule', { value: true });

function createPaddingStyle(padding) {
    if (typeof padding === 'string' || typeof padding === 'number') {
        return { padding: padding };
    }
    if (padding !== null && typeof padding === 'object') {
        return {
            paddingLeft: padding.left,
            paddingRight: padding.right,
            paddingTop: padding.top,
            paddingBottom: padding.bottom,
        };
    }
    return padding;
}

exports.createPaddingStyle = createPaddingStyle;
